import { areIntervalsOverlapping, parseISO } from "date-fns";

import { type Shift } from "../Shift/types";
import { type ShiftInvite } from "./types";

/**
 * Given a proposed shift time and existing shifts, returns the first conflicting shift.
 */
export function getConflictingShift(
  shifts: Shift[],
  proposedShiftTimes: Pick<Shift, "start" | "end">
): Shift | undefined {
  return shifts.find((scheduledShift) => {
    const start = parseISO(scheduledShift.start);
    const end = parseISO(scheduledShift.end);
    const proposedStart = parseISO(proposedShiftTimes.start);
    const proposedEnd = parseISO(proposedShiftTimes.end);

    return areIntervalsOverlapping({ start: proposedStart, end: proposedEnd }, { start, end });
  });
}

/**
 * Given a proposed shift time and existing shift invites, returns all conflicting shift invites.
 */
export function getConflictingShiftInvites(
  shiftInvites: ShiftInvite[],
  proposedShiftTimes: Pick<Shift, "start" | "end">
): ShiftInvite[] {
  const proposedStart = parseISO(proposedShiftTimes.start);
  const proposedEnd = parseISO(proposedShiftTimes.end);

  return shiftInvites.filter((shiftInvite) => {
    const start = parseISO(shiftInvite.attributes.shiftDetails.start);
    const end = parseISO(shiftInvite.attributes.shiftDetails.end);

    return areIntervalsOverlapping({ start: proposedStart, end: proposedEnd }, { start, end });
  });
}
